import * as api from "../api/index";
import {
  ADD_NEW_BANK,
  DELETE_BANK,
  END_LOADING,
  FETCH_ALL_BANK,
  FETCH_ONE_BANK,
  START_LOADING,
} from "./constants";

export const getBank = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchBank(id);
    dispatch({ type: FETCH_ONE_BANK, payload: data });
  } catch (error) {
    console.log(error);
  }
};
export const createBank = (bank, setOpenBank) => async (dispatch) => {
  try {
    const { data } = await api.addBank(bank);

    dispatch({ type: ADD_NEW_BANK, payload: data });
    setOpenBank(false);
  } catch (error) {
    console.log(error);
  }
};
export const deleteBank = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteBank(id);

    dispatch({ type: DELETE_BANK, payload: id });
    openSnackbar("Bank deleted successfully");
  } catch (error) {
    console.log(error);
  }
};
export const getBanks = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchBanks();

    dispatch({ type: FETCH_ALL_BANK, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};
